import { GetMaxDateProps, GetMinDateProps } from 'types/components';

export const getMaxDate = ({ watchedMaxDate, maxDate }: GetMaxDateProps) =>
    watchedMaxDate
        ? new Date(watchedMaxDate)?.setDate(watchedMaxDate?.getDate() - 1)
        : maxDate
        ? new Date(new Date(maxDate)?.setDate(maxDate?.getDate()))
        : false;

export const getMinDate = ({ watchedMinDate, minDate }: GetMinDateProps) =>
    watchedMinDate
        ? new Date(watchedMinDate)?.setDate(watchedMinDate?.getDate() + 1)
        : minDate
        ? new Date(new Date(minDate)?.setDate(minDate?.getDate()))
        : false;

export const emailPattern =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const patternRule = (pattern: any, message: any) => ({
    pattern: {
        value: pattern,
        message: message,
    },
});
